import styledComp from 'styled-components';
import { Styling } from '../../../constants';
import VaultButton from '../VaultButton';

export const Container = styledComp.div`
  margin: 0 auto ${Styling.DEFAULT_SPACING_DOUBLED}px;
  width: 650px;
`;

export const PlayerContainer = styledComp.div`
  border: 10px solid #000;
  
  .vjs-big-play-button {
    display: none !important;
  }
`;

export const ProgressContainer = styledComp.div`
  height: 4px;
`;

export const Controls = styledComp.div`
  align-items: center;
  display: flex;
  justify-content: flex-end;
`;

interface ISliderContainerProps {
  thumbnailSelectable: boolean;
}
export const SliderContainer = styledComp.div<ISliderContainerProps>`
  width: ${(props: ISliderContainerProps) => (props.thumbnailSelectable ? '300px' : '350px')};
  margin-right: ${(props: ISliderContainerProps) => (props.thumbnailSelectable ? '20px' : '36px')};
`;

export const AddPreRollButton = styledComp(VaultButton)`
  margin-right: auto;
`;

export const PlayPauseButton = styledComp(VaultButton)`
  margin-right: auto;
`;
